import brandGuidelinesAgent from 'common/src/modules/brandGuidelines/copilot/brandGuidelinesAgent/brandGuidelinesAgent';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {CLStore} from 'common/src/redux/store';
import {copilot} from '@cl/shared';

function initializeBrandGuidelinesAgents(store: CLStore) {
  if (isFlagEnabled(FeatureFlagKey.EnableCopilotBrandGuidelinesAgent)) {
    copilot.registerAgent(brandGuidelinesAgent(store));
  }
}

export default initializeBrandGuidelinesAgents;
